import { resourceFilePath } from './subResourcePath';
export function runProvideFileSequence(opts) {
    // Bytes belong to a file, so an address clears its whole file.
    const file = resourceFilePath(opts.path);
    opts.fileBus?.invalidate(file);
    // Before the clears, whose announcements start the reloads that record edges anew.
    opts.dependencies?.prune(({ busType, key }) => {
        const processor = opts.processors.get(busType);
        return processor !== undefined && (processor.isCached(key) || processor.isLoading(key));
    });
    const dependents = opts.dependencies?.release(file) ?? [];
    for (const processor of opts.processors.values())
        processor.clearCache(file);
    for (const { busType, key } of dependents)
        opts.processors.get(busType)?.clearCache(key);
}
//# sourceMappingURL=provideFileSequence.js.map